import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Row,
  Col,
  Upload,
} from "antd";
import logo from "../../assets/logo.png";
import QueryBuilder from "../QueryBuilder/Querybuilder";
import districtData from "../../district.json";
import constituencyData from "../../constituency.json";
import localData from "../../districts_mandal.json";
import "../PetitionManagement/PetitionManagement.css";
import { useAuth } from "../AuthContext";
import AcknowledgmentModal from "../Acknowledgement/Acknowledgement";
import {
  UserOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  TeamOutlined,
  AuditOutlined,
  FieldNumberOutlined,
  HomeOutlined,
  DistrictOutlined,
  FileTextOutlined,
  NoteOutlined,
  UploadOutlined,
} from "@ant-design/icons";

const { Option } = Select;
const { TextArea } = Input;

const STATE_OPTIONS = [
  { value: 1, label: "Andhra Pradesh" },
  { value: 2, label: "Telangana" },
];

const PetitionManagement = () => {
  const [departments, setDepartments] = useState([]);
  const [source, setSource] = useState([]);
  const [typeOfPetition, setTypeOfPetition] = useState([]);
  const [Petitionertype, setPetitionerType] = useState([]);
  const [category, setCategories] = useState([]);
  const [assigne, setAssigne] = useState([]);
  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const [type, setSurveyType] = useState("");
  const [districts, setDistricts] = useState([]);
  const [constituencies, setConstituencies] = useState([]);
  const [mandals, setMandals] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedConstituency, setSelectedConstituency] = useState(null);

  const [fileList, setFileList] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [assignees, setAssignees] = useState([]);
  const [acknowledgmentModalVisible, setAcknowledgmentModalVisible] =
    useState(false); // State to control acknowledgment modal
  const [acknowledgmentData, setAcknowledgmentData] = useState({});

  const [priorityOptions, setPriorityOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [callNotesOptions, setCallNotesOptions] = useState([]);
  const [notesOptions, setNotesOptions] = useState([]);
  const [solutionType, setSolutionType] = useState([]);
  const [feedbackOptions, setFeedbackOptions] = useState([]);
  const [legalitiesOptions, setLegalitiesOptions] = useState([]);
  const [severityOptions, setSeverityOptions] = useState([]);

  const fetchDropdownOptions = async (fieldType, setOptions) => {
    try {
      const response = await fetch(
        `/api/portal/pms/get_pms_item_list?field_type=${fieldType}`
      );
      if (response.status === 200) {
        const data = await response.json(); // Parse the response data

        let formattedData;
        // Conditionally format data based on fieldType
        if (
          fieldType === "source" ||
          fieldType === "category" ||
          fieldType === "Legalities" ||
          fieldType === "Severity" ||
          fieldType === "type_of_petition" ||
          fieldType === "petitioner_Type" ||
          fieldType === "solution_Type" ||
          fieldType === "Priortiy" ||
          fieldType === "priority"
        ) {
          // Format for `source` and `category`
          formattedData = data.map((item) => ({
            value: item.name, // Set value as `name`
            label: item.name, // Set label as `name`
          }));
        } else {
          // Default format for other dropdowns
          formattedData = data.map((item) => ({
            value: item.seq_id, // Use `seq_id` as value for other dropdowns
            label: item.name, // Use `name` as label
          }));
        }

        // Set options in the component's state
        setOptions(formattedData);
        console.log("Formatted Data:", formattedData);
      } else {
        message.error("Failed to fetch options");
      }
    } catch (error) {
      message.error("Error fetching options");
      console.error("Error:", error);
    }
  };

  const { userRole } = useAuth();
  const onFinish = (values) => {
    console.log("Form Values:", values);
    handleAddPetition(values);
  };

  const showModal = () => {
    setModalVisible(true);
  };

  const handleCancel = () => {
    setModalVisible(false);
    form.resetFields();
    setSelectedState(null);
    setSelectedDistrict(null);
    setSelectedConstituency(null);
    setDistricts([]);
    setConstituencies([]);
    setMandals([]);
  };

  useEffect(() => {
    if (modalVisible) {
      fetchAssignees();
      fetchDepartments();
      loadLocalData();
      // fetchCategory();
      fetchAttache();
      // fetchSource();
    }
  }, [modalVisible]);

  // const fetchSource = async () => {
  //   try {
  //     const response = await fetch("/api/portal/pms/get_pms_source_list");
  //     if (response.ok) {
  //       const data = await response.json();
  //       setSource(
  //         data.map((dept) => ({
  //           value: dept.name,
  //           label: dept.name,
  //         }))
  //       );
  //     } else {
  //       console.error("Failed to fetch departments");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching departments:", error);
  //   }
  // };

  // const fetchCategory = async () => {
  //   try {
  //     const response = await fetch("/api/portal/pms/get_pms_categories");
  //     if (response.ok) {
  //       const data = await response.json();
  //       setCategories(
  //         data.map((dept) => ({
  //           value: dept.name,
  //           label: dept.name,
  //         }))
  //       );
  //     } else {
  //       console.error("Failed to fetch departments");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching departments:", error);
  //   }
  // };

  const fetchAttache = async () => {
    try {
      const response = await fetch("/api/portal/pms/get_pms_assignee_list");
      if (response.ok) {
        const data = await response.json();
        setAssigne(
          data.map((dept) => ({
            value: dept.name,
            label: dept.name,
          }))
        );
      } else {
        console.error("Failed to fetch departments");
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const loadLocalData = () => {
    setDistricts([]);
    setConstituencies([]);
    setMandals([]);
  };

  const getByKey = (data, key) => data[key] || data[String(key)] || [];

  const handleStateChange = (stateId) => {
    setSelectedState(stateId);
    setSelectedDistrict(null);
    setSelectedConstituency(null);
    form.setFieldsValue({ district: null, constituency: null, mandal: null });

    const districtsForState = getByKey(districtData, stateId).map(
      (district) => ({
        value: district.id,
        label: district.district_name,
      })
    );

    setDistricts(districtsForState);
    setConstituencies([]);
    setMandals([]);
  };

  const handleDistrictChange = (districtId) => {
    setSelectedDistrict(districtId);
    setSelectedConstituency(null);
    form.setFieldsValue({ constituency: null, mandal: null });

    const constituenciesForDistrict = getByKey(
      constituencyData,
      districtId
    ).map((constituency) => ({
      value: constituency.constituency_id,
      label: constituency.constituency_name,
    }));

    setConstituencies(constituenciesForDistrict);
    setMandals([]);
  };

  const handleConstituencyChange = (constituencyId) => {
    setSelectedConstituency(constituencyId);
    form.setFieldsValue({ mandal: null });

    const districtId = form.getFieldValue("district");
    const stateId = form.getFieldValue("state");
    const seen = new Set();
    const filteredMandals = localData
      .filter(
        (item) =>
          item.constituency_id === constituencyId &&
          item.district_id === districtId &&
          (stateId == null || item.state_id === stateId)
      )
      .reduce((acc, item) => {
        if (!seen.has(item.id)) {
          seen.add(item.id);
          acc.push({
            value: item.id,
            label: item.mandal_name,
          });
        }
        return acc;
      }, []);

    setMandals(filteredMandals);
  };

  const handleAddPetition = async (values) => {
    // Construct the payload with form values and uploaded files
    const priorityValue = values.priority || values.Priortiy || "";
    const severityValue = values.severity || values["Severity  "] || "";
    const legalitiesValue = values.legalities || values["Legalities "] || "";
    const feedbackNotesValue =
      values.feedbacknotes || values["feedbacknotes "] || "";
    const representationValue =
      values.representation || values["Representation "] || "";
    const petitionTypeValue =
      values.petition_type || values.type_of_petition || "";
    const petitionerTypeValue =
      values.petitioner_type || values.petitioner_Type || "";

    const payload = {
      state_id: values.state,
      district_id: values.district,
      files: uploadedFiles,
      mandal: values.mandal,
      mandal_id: values.mandal,
      fullname: values.name,
      name: values.name,
      mobile: values.phoneNumber,
      emergency_mobile: values.emergency_mobile,
      email: values.email,
      age: values.age,
      location: values.location,
      address: values.location,
      title: values.subject,
      constituency_id: values.constituency,
      village: values.village,
      source: values.source,
      category: values.category,
      attache: values.assignee,
      concerned_authority: values.concernedAuthority,
      department: values.department,
      petition_type: petitionTypeValue,
      petitioner_type: petitionerTypeValue,
      priority: priorityValue,
      severity: severityValue,
      typeofPetition: values.type_of_petition,
      petitionerType: values.petitioner_Type,
      solutiontype: values.solution_type,
      solution_type: values.solution_type,
      callNOtes: values.CallNotes,
      legalities: legalitiesValue,
      Legalities: legalitiesValue,
      FeedbackType: values.Feedback_Type,
      Feedback_Notes: feedbackNotesValue,
      representation: representationValue,
      Representation: representationValue,
      Severity: severityValue,

      // assignees: values.assignee,
      // pms_status: values.status,
      // political_dividend:
      //   values.status === "yes" ? values.politicalDividend : undefined,
      // additionalInfo:
      //   values.status === "no" ? values.additionalInfo : undefined,
      // additionnotes: values.status === "no" ? values.additionnotes : undefined,
      notes: values.notes,
    };

    // Send the payload to your desired endpoint as JSON
    try {
      const response = await fetch("/api/portal/pms/add_pms", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        message.success("Petition added successfully");
        const data = await response.json();
        setAcknowledgmentData(data.serviceResult.result);
        setAcknowledgmentModalVisible(true);
        handleCancel();
      } else {
        message.error("Failed to add petition");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Error adding petition");
    }
  };

  const customUpload = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("pms_file", file);

    try {
      const uploadResponse = await fetch("/api/portal/pms/upload_pms_files", {
        method: "POST",
        body: formData,
      });

      if (uploadResponse.ok) {
        const uploadData = await uploadResponse.json();
        const newFile = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: uploadData.serviceResult.url,
        };

        setFileList((prevFileList) => [...prevFileList, newFile]);
        setUploadedFiles((prevUploadedFiles) => [
          ...prevUploadedFiles,
          newFile.url,
        ]);

        onSuccess(uploadData);
      } else {
        onError(new Error("Upload failed"));
      }
    } catch (error) {
      console.error("Error:", error);
      onError(error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await fetch("/api/portal/pms/get_pms_departments");
      const data = await response.json();
      setDepartments(data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };
  const fetchAssignees = async () => {
    try {
      const response = await fetch("/api/portal/pms/get_all_pms_Assignees");
      const data = await response.json();
      if (data.serviceResult) {
        setAssignees(data.serviceResult);
      }
    } catch (error) {
      console.error("Error fetching assignees:", error);
    }
  };

  return (
    <div>
      <Modal
        open={modalVisible}
        onOk={() => form.submit()}
        onCancel={handleCancel}
        title="Public Grievance Form"
        width={1100}
        maskClosable={false}
        style={{ top: 20 }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={logo}
            style={{ width: 60, marginRight: 20 }}
            alt="Pulse Logo"
          />
          <h2 style={{ margin: 0 }}>Janasena</h2>
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: 20 }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Petitioner Name"
                rules={[{ required: true, message: "Please enter your name" }]}
              >
                <Input placeholder="Enter your name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="age"
                label="age"
                rules={[{ required: true, message: "Please enter age" }]}
              >
                <Input placeholder="Enter the age" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="phoneNumber"
                label="Phone Number"
                rules={[
                  { required: true, message: "Please enter your phone number" },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Please enter a valid phone number",
                  },
                ]}
              >
                <Input placeholder="Enter your phone number" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="emergency_mobile"
                label="Emergency Phone Number"
                rules={[
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Please enter a valid emergency phone number",
                  },
                ]}
              >
                <Input placeholder="Enter emergency phone number" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="state"
                label="State"
                rules={[{ required: true, message: "Please select a state" }]}
              >
                <Select
                  placeholder="Select State"
                  onChange={handleStateChange}
                  showSearch
                  optionFilterProp="children"
                >
                  {STATE_OPTIONS.map((state) => (
                    <Option key={state.value} value={state.value}>
                      {state.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="district"
                label="District"
                rules={[
                  { required: true, message: "Please select a district" },
                ]}
              >
                <Select
                  placeholder="Select District"
                  onChange={handleDistrictChange}
                  disabled={!selectedState}
                  showSearch
                  optionFilterProp="children"
                >
                  {districts.map((dist) => (
                    <Option key={dist.value} value={dist.value}>
                      {dist.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="constituency"
                label="Constituency"
                rules={[
                  { required: true, message: "Please select a constituency" },
                ]}
              >
                <Select
                  placeholder="Select Constituency"
                  onChange={handleConstituencyChange}
                  disabled={!selectedDistrict}
                  showSearch
                  optionFilterProp="children"
                >
                  {constituencies.map((cons) => (
                    <Option key={cons.value} value={cons.value}>
                      {cons.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="mandal"
                label="Mandal"
                rules={[
                  { required: true, message: "Please select a mandal" },
                ]}
              >
                <Select
                  placeholder="Select Mandal"
                  disabled={!selectedConstituency}
                  showSearch
                  optionFilterProp="children"
                >
                  {mandals.map((mandal) => (
                    <Option key={mandal.value} value={mandal.value}>
                      {mandal.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="village"
                label="Village"
                rules={[{ required: true, message: "Please enter village" }]}
              >
                <Input placeholder="Enter your village" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="legalities" label="Legalities">
                <Select
                  placeholder="Select Legalities"
                  onDropdownVisibleChange={(open) =>
                    open &&
                    fetchDropdownOptions("Legalities", setLegalitiesOptions)
                  }
                >
                  {legalitiesOptions.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="Priortiy"
                label="Priority"
                rules={[
                  { required: true, message: "Please select a priority" },
                ]}
              >
                <Select
                  placeholder="Select a priority"
                  onDropdownVisibleChange={(open) =>
                    open && fetchDropdownOptions("priority", setPriorityOptions)
                  }
                >
                  {priorityOptions.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="severity"
                label="Severity"
                rules={[{ required: true, message: "Please select severity" }]}
              >
                <Select
                  placeholder="Select a priority"
                  onDropdownVisibleChange={(open) =>
                    open && fetchDropdownOptions("Severity", setSeverityOptions)
                  }
                >
                  {severityOptions.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="source"
                label="Source"
                rules={[{ required: true, message: "Please select a Source" }]}
              >
                <Select
                  placeholder="Select a source"
                  onDropdownVisibleChange={(open) =>
                    open && fetchDropdownOptions("source", setSource)
                  }
                >
                  {source.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="solution_type"
                label="solution Type"
                rules={[
                  { required: true, message: "Please select a solution type" },
                ]}
              >
                <Select
                  placeholder="Select a solution type"
                  onDropdownVisibleChange={(open) =>
                    open &&
                    fetchDropdownOptions("solution_Type", setSolutionType)
                  }
                >
                  {solutionType.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="category"
                label="Category"
                rules={[
                  { required: true, message: "Please select a category" },
                ]}
              >
                <Select
                  placeholder="Select a category"
                  onDropdownVisibleChange={(open) =>
                    open && fetchDropdownOptions("category", setCategories)
                  }
                >
                  {category.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label={<span>Attache </span>} name="assignee">
                <Select placeholder="Select an assignee">
                  {assignees.map((assignee) => (
                    <Option key={assignee.seq_id} value={assignee.user_name}>
                      {assignee.first_name} {assignee.last_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="type_of_petition"
                label="Type Of Petition"
                rules={[
                  {
                    required: true,
                    message: "Please select a Type Of Petition",
                  },
                ]}
              >
                <Select
                  placeholder="Select a Type Of Petition"
                  onDropdownVisibleChange={(open) =>
                    open &&
                    fetchDropdownOptions("type_of_petition", setTypeOfPetition)
                  }
                >
                  {typeOfPetition.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="petitioner_Type"
                label="Petitioner Type"
                rules={[
                  {
                    required: true,
                    message: "Please select a Petitioner type",
                  },
                ]}
              >
                <Select
                  placeholder="Select a Petitioner type"
                  onDropdownVisibleChange={(open) =>
                    open &&
                    fetchDropdownOptions("petitioner_Type", setPetitionerType)
                  }
                >
                  {Petitionertype.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="Representation " label="Representation">
                <TextArea placeholder="Enter your Representation" rows={3} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="files" label="Upload Files">
                <Upload
                  customRequest={customUpload}
                  fileList={fileList}
                  onChange={({ fileList }) => setFileList(fileList)}
                  multiple
                  listType="picture"
                  beforeUpload={(file) => {
                    const isAllowedType =
                      file.type === "image/png" ||
                      file.type === "image/jpeg" ||
                      file.type === "image/jpg" ||
                      file.type === "application/pdf";

                    if (!isAllowedType) {
                      message.error(
                        "You can only upload PNG, JPG, JPEG, or PDF files!"
                      );
                    }
                    return isAllowedType || Upload.LIST_IGNORE;
                  }}
                  accept=".png,.jpg,.jpeg,.pdf"
                >
                  <Button icon={<UploadOutlined />}>Select Files</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AcknowledgmentModal
        visible={acknowledgmentModalVisible}
        onClose={() => setAcknowledgmentModalVisible(false)}
        acknowledgmentData={acknowledgmentData}
      />
      <QueryBuilder
        title={"Petition Management"}
        Headername={"/api/portal/reports/get_pms_table_metadata"}
        Rulesdata={"/api/portal/reports/get_pms_filters"}
        Databyquery={"/api/portal/reports/get_pms_data"}
        addPetitionbutton={userRole == "PAT" || userRole == "AD" ? true : false}
        addpetition={showModal}
        petitionmanagementactions={true}
      />
    </div>
  );
};

export default PetitionManagement;
